import { ChangeDetectionStrategy, Component, input, model } from "@angular/core";
import { DspCustomCreativesLinesComponent } from "@m19-board/dsp/dsp-creatives/dsp-custom-creatives/dsp-custom-creatives-table/dsp-custom-creatives-lines.component";
import {
  ICheckboxComponent,
  ITableBodyDirective,
  ITableDirective,
  ITableHeadDirective,
  ITableRowDirective,
  ITableThDirective,
} from "@front/m19-ui";
import { TitleCasePipe } from "@angular/common";
import { TranslocoDirective } from "@jsverse/transloco";
import { DspCreative } from "@front/m19-api-client";

@Component({
  selector: "app-dsp-custom-creatives-table",
  imports: [
    DspCustomCreativesLinesComponent,
    ITableBodyDirective,
    ITableDirective,
    ITableHeadDirective,
    ITableRowDirective,
    ITableThDirective,
    TitleCasePipe,
    TranslocoDirective,
    ICheckboxComponent,
  ],
  template: `
    <table iTable *transloco="let t">
      <thead iTableHead>
        <th class="p-1">
          <ICheckbox
            (valueChange)="selectOrUnselectAllCreatives($event)"
            [value]="dspCreatives().length > 0 && selectedCreatives().size === dspCreatives().length"
          />
        </th>
        <th iTableTh>{{ t("common.creative") | titlecase }}</th>
        <th iTableTh>{{ t("sb-form-assets.title") | titlecase }}</th>
        <th iTableTh>{{ t("common.product") | titlecase }}</th>
      </thead>
      <tbody iTableBody>
        @for (creative of dspCreatives(); track creative.adCreativeId) {
          @let isSelected = selectedCreatives().has(creative.adCreativeId);
          <tr
            app-dsp-custom-creatives-lines
            iTableRow
            class="cursor-pointer"
            [creative]="creative"
            (click)="selectOrUnselectCreative(!isSelected, creative)"
            [isSelected]="isSelected"
            (isSelectedChange)="selectOrUnselectCreative($event, creative)"
          ></tr>
        } @empty {
          <tr class="text-center text-sm text-gray-700">
            <td colspan="5" class="h-18">
              {{ t("dsp-creatives.no_dsp_creatives_found") }}
            </td>
          </tr>
        }
      </tbody>
    </table>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DspCustomCreativesTableComponent {
  dspCreatives = input.required<DspCreative[]>();

  selectedCreatives = model.required<Set<string>>();

  selectOrUnselectAllCreatives(selected: boolean) {
    this.selectedCreatives.update((creatives) => {
      if (!selected) {
        creatives.clear();
        return creatives;
      }

      this.dspCreatives().forEach((creative) => creatives.add(creative.adCreativeId));
      return creatives;
    });
  }

  selectOrUnselectCreative(selected: boolean, creative: DspCreative) {
    this.selectedCreatives.update((creatives) => {
      if (!selected) {
        creatives.delete(creative.adCreativeId);
        return creatives;
      }

      return creatives.add(creative.adCreativeId);
    });
  }
}
